import { render, staticRenderFns } from "./TimeWidget.vue?vue&type=template&id=2f6ccfa1&scoped=true&"
import script from "./TimeWidget.vue?vue&type=script&lang=js&"
export * from "./TimeWidget.vue?vue&type=script&lang=js&"
import style0 from "./TimeWidget.vue?vue&type=style&index=0&id=2f6ccfa1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6ccfa1",
  null
  
)

export default component.exports